<div class="h-full w-full flex flex-col min-h-0 overflow-hidden">
    <div class="p-4 flex flex-col gap-4 flex-1 min-h-0 overflow-y-auto">
        <!-- INPUT SECTION -->
        @if (inputText()) {
        <div class="flex-shrink-0 flex flex-col gap-2">
            <p class="text-xs text-zinc-600 font-medium">Input</p>
            <div class="text-sm text-zinc-900 font-mono">{{ inputText() }}</div>
        </div>
        }

        <!-- OUTPUT SECTION -->
        @if (toolContent()) {
        <div class="flex flex-col flex-1 gap-2 min-h-0 bg-zinc-50 rounded-lg p-3 h-auto max-h-full overflow-hidden">
            <p class="text-xs text-zinc-600 font-medium">Output</p>

            <!-- READ FILE: Render markdown -->
            @if (isReadFile()) {
            <div class="prose prose-sm max-w-none text-zinc-900 overflow-y-auto"
                [innerHTML]="strippedContent() | markdownRender" dynamicComponentRenderer></div>
            }

            <!-- LIST FILES: Simple list -->
            @else if (isListFiles()) {
            <div class="font-mono text-sm text-zinc-900 whitespace-pre">{{ parsedFileList() }}</div>
            }

            <!-- FALLBACK: Plain text -->
            @else {
            <pre class="text-sm text-zinc-900 whitespace-pre-wrap font-mono">{{ toolContent() }}</pre>
            }
        </div>
        }
    </div>
</div>
